// Per-case-type model -> image index maps. Each product type has its own photography, so the
// same phone model can map to a different image slot depending on which case type the current
// product is (index meaning is defined per file in docs/Phone Model Mapping/, not universal —
// e.g. Silicone Case uses a slot 8 that no other case type has). Sourced 2026-09-03 from the 5
// case-type CSVs in that folder.
var WRAPGRAM_IMAGE_MAP = {
  'Glass Case': {
    'iphone-17-pro-max': 3, 'iphone-17-pro': 3, 'iphone-17-air': 3, 'iphone-17': 1, 'iphone-17e': 1, 'iphone-16-pro-max': 4,
    'iphone-16-pro': 4, 'iphone-16-plus': 1, 'iphone-16': 1, 'iphone-16e': 1, 'iphone-15-pro-max': 4, 'iphone-15-pro': 4,
    'iphone-15-plus': 2, 'iphone-15': 2, 'iphone-14-pro-max': 5, 'iphone-14-pro': 5, 'iphone-14-plus': 2, 'iphone-14': 2,
    'iphone-13-pro-max': 5, 'iphone-13-pro': 5, 'iphone-13': 2, 'iphone-13-mini': 2, 'iphone-se-2022': 2, 'iphone-12-pro-max': 5,
    'iphone-12-pro': 5, 'iphone-12': 2, 'iphone-12-mini': 2, 'iphone-11-pro-max': 5, 'iphone-11-pro': 5, 'iphone-11': 2,
    'iphone-xs-max': 1, 'iphone-xs': 1, 'iphone-x': 1, 'iphone-xr': 1, 'iphone-se-2020': 1, 'iphone-8-plus': 2,
    'iphone-8': 2, 'iphone-7-plus': 2, 'iphone-7': 2, 'iphone-6s-plus': 2, 'iphone-6s': 2, 'iphone-6-plus': 2,
    'iphone-6': 2, 'galaxy-z-fold-7': 6, 'galaxy-z-fold-6': 6, 'galaxy-z-fold-5': 6, 'galaxy-z-fold-4': 6, 'galaxy-z-fold-3': 6,
    'galaxy-z-flip-7': 6, 'galaxy-z-flip-6': 6, 'galaxy-z-flip-5': 6, 'galaxy-z-flip-4': 6, 'galaxy-z-flip-3': 6, 'galaxy-s26-ultra': 7,
    'galaxy-s26-plus': 6, 'galaxy-s26': 6, 'galaxy-s25-ultra': 7, 'galaxy-s25-edge': 6, 'galaxy-s25-plus': 6, 'galaxy-s25': 6,
    'galaxy-s25-fe': 6, 'galaxy-s24-ultra': 7, 'galaxy-s24-plus': 6, 'galaxy-s24': 6, 'galaxy-s24-fe': 6, 'galaxy-s23-ultra': 7,
    'galaxy-s23-plus': 6, 'galaxy-s23': 6, 'galaxy-s23-fe': 6, 'galaxy-s22-ultra': 7, 'galaxy-s22-plus': 6, 'galaxy-s22': 6,
    'galaxy-s21-ultra': 7, 'galaxy-s21-plus': 6, 'galaxy-s21': 6, 'galaxy-s21-fe': 6, 'galaxy-s20-ultra': 7, 'galaxy-s20-plus': 6,
    'galaxy-s20': 6, 'galaxy-s20-fe': 6, 'galaxy-s10-plus': 6, 'galaxy-s10-lite': 6, 'galaxy-s9': 6, 'galaxy-s8-plus': 6,
    'galaxy-s8': 6, 'galaxy-note-20-ultra': 7, 'galaxy-note-20': 6, 'galaxy-note-10-plus': 6, 'galaxy-note-10': 6, 'galaxy-note-10-lite': 6,
    'galaxy-a91': 6, 'galaxy-a81': 6, 'galaxy-a73': 6, 'galaxy-a72': 6, 'galaxy-a71': 6, 'galaxy-a70': 6,
    'galaxy-a70s': 6, 'galaxy-a57': 6, 'galaxy-a56': 6, 'galaxy-a55': 6, 'galaxy-a54': 6, 'galaxy-a53': 6,
    'galaxy-a52': 6, 'galaxy-a52s': 6, 'galaxy-a51': 6, 'galaxy-a40': 6, 'galaxy-a40s': 6, 'galaxy-a37': 6,
    'galaxy-a36': 6, 'galaxy-a35': 6, 'galaxy-a34': 6, 'galaxy-a33': 6, 'galaxy-a32-5g': 6, 'galaxy-a32-4g': 6,
    'galaxy-a31': 6, 'galaxy-a27': 6, 'galaxy-a26': 6, 'galaxy-a25': 6, 'galaxy-a23': 6, 'galaxy-a22-5g': 6,
    'galaxy-a22-4g': 6, 'galaxy-a17': 6, 'galaxy-a16': 6, 'galaxy-a15': 6, 'galaxy-a14-5g': 6, 'galaxy-a14-4g': 6,
    'galaxy-a11': 6, 'galaxy-a10': 6, 'galaxy-a10s': 6, 'galaxy-a06': 6, 'galaxy-a05s': 6, 'galaxy-a04': 6,
    'galaxy-a03s': 6, 'galaxy-a02s': 6, 'galaxy-f62': 6, 'galaxy-f56': 6, 'galaxy-f55': 6, 'galaxy-f54': 6,
    'galaxy-f42': 6, 'galaxy-f36': 6, 'galaxy-f34': 6, 'galaxy-f23': 6, 'galaxy-f22': 6, 'galaxy-f16': 6,
    'galaxy-f15': 6, 'galaxy-f14': 6, 'galaxy-f07': 6, 'galaxy-f06': 6, 'galaxy-f02s': 6, 'galaxy-m62': 6,
    'galaxy-m56': 6, 'galaxy-m55': 6, 'galaxy-m54': 6, 'galaxy-m53': 6, 'galaxy-m52': 6, 'galaxy-m51': 6,
    'galaxy-m36': 6, 'galaxy-m35': 6, 'galaxy-m34': 6, 'galaxy-m33': 6, 'galaxy-m32': 6, 'galaxy-m30': 6,
    'galaxy-m30s': 6, 'galaxy-m23': 6, 'galaxy-m21': 6, 'galaxy-m21-2021': 6, 'galaxy-m17': 6, 'galaxy-m16': 6,
    'galaxy-m15': 6, 'galaxy-m14': 6, 'galaxy-m11': 6, 'galaxy-m10': 6, 'galaxy-m07': 6, 'galaxy-m06': 6,
    'galaxy-m02s': 6,
  },
  'Hybrid Case': {
    'iphone-17-pro-max': 3, 'iphone-17-pro': 3, 'iphone-17-air': 3, 'iphone-17': 1, 'iphone-17e': 1, 'iphone-16-pro-max': 4,
    'iphone-16-pro': 4, 'iphone-16-plus': 1, 'iphone-16': 1, 'iphone-16e': 1, 'iphone-15-pro-max': 4, 'iphone-15-pro': 4,
    'iphone-15-plus': 2, 'iphone-15': 2, 'iphone-14-pro-max': 5, 'iphone-14-pro': 5, 'iphone-14-plus': 2, 'iphone-14': 2,
    'iphone-13-pro-max': 5, 'iphone-13-pro': 5, 'iphone-13': 2, 'iphone-13-mini': 2, 'iphone-se-2022': 2, 'iphone-12-pro-max': 5,
    'iphone-12-pro': 5, 'iphone-12': 2, 'iphone-12-mini': 2, 'iphone-11-pro-max': 5, 'iphone-11-pro': 5, 'iphone-11': 2,
    'iphone-xs-max': 1, 'iphone-xs': 1, 'iphone-x': 1, 'iphone-xr': 1, 'iphone-se-2020': 1, 'iphone-8-plus': 2,
    'iphone-8': 2, 'iphone-7-plus': 2, 'iphone-7': 2, 'galaxy-z-fold-7': 6, 'galaxy-z-fold-6': 6, 'galaxy-z-fold-5': 6,
    'galaxy-z-fold-4': 6, 'galaxy-z-fold-3': 6, 'galaxy-z-flip-7': 6, 'galaxy-z-flip-6': 6, 'galaxy-z-flip-5': 6, 'galaxy-z-flip-4': 6,
    'galaxy-z-flip-3': 6, 'galaxy-s26-ultra': 7, 'galaxy-s26-plus': 6, 'galaxy-s26': 6, 'galaxy-s25-ultra': 7, 'galaxy-s25-edge': 6,
    'galaxy-s25-plus': 6, 'galaxy-s25': 6, 'galaxy-s25-fe': 6, 'galaxy-s24-ultra': 7, 'galaxy-s24-plus': 6, 'galaxy-s24': 6,
    'galaxy-s24-fe': 6, 'galaxy-s23-ultra': 7, 'galaxy-s23-plus': 6, 'galaxy-s23': 6, 'galaxy-s23-fe': 6, 'galaxy-s22-ultra': 7,
    'galaxy-s22-plus': 6, 'galaxy-s22': 6, 'galaxy-s21-ultra': 7, 'galaxy-s21-plus': 6, 'galaxy-s21': 6, 'galaxy-s21-fe': 6,
    'galaxy-s20-ultra': 7, 'galaxy-s20-plus': 6, 'galaxy-s20': 6, 'galaxy-s20-fe': 6, 'galaxy-s10-plus': 6, 'galaxy-s10': 6,
    'galaxy-s10-lite': 6, 'galaxy-s10e': 6, 'galaxy-s9': 6, 'galaxy-s8-plus': 6, 'galaxy-s8': 6, 'galaxy-note-20-ultra': 7,
    'galaxy-note-20': 6, 'galaxy-note-10-plus': 6, 'galaxy-note-10': 6, 'galaxy-note-10-lite': 6, 'galaxy-a91': 6, 'galaxy-a81': 6,
    'galaxy-a73': 6, 'galaxy-a72': 6, 'galaxy-a71': 6, 'galaxy-a70': 6, 'galaxy-a70s': 6, 'galaxy-a57': 6,
    'galaxy-a56': 6, 'galaxy-a55': 6, 'galaxy-a54': 6, 'galaxy-a53': 6, 'galaxy-a52': 6, 'galaxy-a52s': 6,
    'galaxy-a51': 6, 'galaxy-a50': 6, 'galaxy-a50s': 6, 'galaxy-a40': 6, 'galaxy-a40s': 6, 'galaxy-a37': 6,
    'galaxy-a36': 6, 'galaxy-a35': 6, 'galaxy-a34': 6, 'galaxy-a33': 6, 'galaxy-a32-5g': 6, 'galaxy-a32-4g': 6,
    'galaxy-a31': 6, 'galaxy-a30s': 6, 'galaxy-a27': 6, 'galaxy-a26': 6, 'galaxy-a25': 6, 'galaxy-a23': 6,
    'galaxy-a22-5g': 6, 'galaxy-a22-4g': 6, 'galaxy-a17': 6, 'galaxy-a16': 6, 'galaxy-a15': 6, 'galaxy-a14-5g': 6,
    'galaxy-a14-4g': 6, 'galaxy-a12': 6, 'galaxy-a11': 6, 'galaxy-a10': 6, 'galaxy-a10s': 6, 'galaxy-a06': 6,
    'galaxy-a02s': 6, 'galaxy-f62': 6, 'galaxy-f56': 6, 'galaxy-f55': 6, 'galaxy-f54': 6, 'galaxy-f42': 6,
    'galaxy-f41': 6, 'galaxy-f36': 6, 'galaxy-f34': 6, 'galaxy-f23': 6, 'galaxy-f22': 6, 'galaxy-f17': 6,
    'galaxy-f16': 6, 'galaxy-f15': 6, 'galaxy-f14': 6, 'galaxy-f12': 6, 'galaxy-f07': 6, 'galaxy-f06': 6,
    'galaxy-f02s': 6, 'galaxy-m62': 6, 'galaxy-m56': 6, 'galaxy-m55': 6, 'galaxy-m54': 6, 'galaxy-m53': 6,
    'galaxy-m52': 6, 'galaxy-m51': 6, 'galaxy-m36': 6, 'galaxy-m35': 6, 'galaxy-m34': 6, 'galaxy-m33': 6,
    'galaxy-m32': 6, 'galaxy-m31': 6, 'galaxy-m31-prime': 6, 'galaxy-m31s': 6, 'galaxy-m30': 6, 'galaxy-m30s': 6,
    'galaxy-m21': 6, 'galaxy-m21-2021': 6, 'galaxy-m16': 6, 'galaxy-m14': 6, 'galaxy-m12': 6, 'galaxy-m11': 6,
    'galaxy-m10': 6, 'galaxy-m07': 6, 'galaxy-m06': 6, 'galaxy-m02s': 6,
  },
  'Flex Case': {
    'iphone-17-pro-max': 3, 'iphone-17-pro': 3, 'iphone-17-air': 5, 'iphone-17': 1, 'iphone-17e': 2, 'iphone-16-pro-max': 4,
    'iphone-16-pro': 4, 'iphone-16-plus': 1, 'iphone-16': 1, 'iphone-16e': 2, 'iphone-15-pro-max': 4, 'iphone-15-pro': 4,
    'iphone-15-plus': 2, 'iphone-15': 2, 'iphone-14-pro-max': 4, 'iphone-14-pro': 4, 'iphone-14-plus': 2, 'iphone-14': 2,
    'iphone-13-pro-max': 4, 'iphone-13-pro': 4, 'iphone-13': 2, 'iphone-13-mini': 2, 'iphone-se-2022': 1, 'iphone-12-pro-max': 4,
    'iphone-12-pro': 4, 'iphone-12': 2, 'iphone-12-mini': 2, 'iphone-11-pro-max': 4, 'iphone-11-pro': 4, 'iphone-11': 2,
    'iphone-xs-max': 1, 'iphone-xs': 1, 'iphone-x': 1, 'iphone-xr': 1, 'iphone-se-2020': 2, 'iphone-8-plus': 2,
    'iphone-8': 2, 'iphone-7-plus': 2, 'iphone-7': 2, 'galaxy-s26-ultra': 7, 'galaxy-s26-plus': 6, 'galaxy-s26': 6,
    'galaxy-s25-ultra': 7, 'galaxy-s25-edge': 6, 'galaxy-s25-plus': 6, 'galaxy-s25': 6, 'galaxy-s25-fe': 6, 'galaxy-s24-ultra': 7,
    'galaxy-s24-plus': 6, 'galaxy-s24': 6, 'galaxy-s24-fe': 6, 'galaxy-s23-ultra': 7, 'galaxy-s23-plus': 6, 'galaxy-s23': 6,
    'galaxy-s23-fe': 6, 'galaxy-s22-ultra': 7, 'galaxy-s22-plus': 6, 'galaxy-s22': 6, 'galaxy-s21-ultra': 7, 'galaxy-s21-plus': 6,
    'galaxy-s21': 6, 'galaxy-s21-fe': 6, 'galaxy-s20-fe': 6, 'galaxy-s10-plus': 6, 'galaxy-s10': 6, 'galaxy-s10-lite': 6,
    'galaxy-note-20-ultra': 7, 'galaxy-note-20': 6, 'galaxy-note-10-plus': 6, 'galaxy-note-10-lite': 6, 'galaxy-a91': 6, 'galaxy-a81': 6,
    'galaxy-a73': 6, 'galaxy-a71': 6, 'galaxy-a57': 6, 'galaxy-a56': 6, 'galaxy-a55': 6, 'galaxy-a54': 6,
    'galaxy-a53': 6, 'galaxy-a52': 6, 'galaxy-a52s': 6, 'galaxy-a51': 6, 'galaxy-a50': 6, 'galaxy-a50s': 6,
    'galaxy-a37': 6, 'galaxy-a36': 6, 'galaxy-a35': 6, 'galaxy-a34': 6, 'galaxy-a33': 6, 'galaxy-a31': 6,
    'galaxy-a30s': 6, 'galaxy-a27': 6, 'galaxy-a26': 6, 'galaxy-a25': 6, 'galaxy-a23': 6, 'galaxy-a22-5g': 6,
    'galaxy-a22-4g': 6, 'galaxy-a17': 6, 'galaxy-a16': 6, 'galaxy-a15': 6, 'galaxy-a14-5g': 6, 'galaxy-a14-4g': 6,
    'galaxy-a12': 6, 'galaxy-a06': 6, 'galaxy-f62': 6, 'galaxy-f56': 6, 'galaxy-f55': 6, 'galaxy-f54': 6,
    'galaxy-f42': 6, 'galaxy-f41': 6, 'galaxy-f36': 6, 'galaxy-f34': 6, 'galaxy-f23': 6, 'galaxy-f22': 6,
    'galaxy-f17': 6, 'galaxy-f16': 6, 'galaxy-f15': 6, 'galaxy-f14': 6, 'galaxy-f12': 6, 'galaxy-f07': 6,
    'galaxy-f06': 6, 'galaxy-m62': 6, 'galaxy-m56': 6, 'galaxy-m55': 6, 'galaxy-m54': 6, 'galaxy-m53': 6,
    'galaxy-m52': 6, 'galaxy-m51': 6, 'galaxy-m36': 6, 'galaxy-m35': 6, 'galaxy-m34': 6, 'galaxy-m33': 6,
    'galaxy-m32': 6, 'galaxy-m31': 6, 'galaxy-m31-prime': 6, 'galaxy-m31s': 6, 'galaxy-m30s': 6, 'galaxy-m23': 6,
    'galaxy-m21': 6, 'galaxy-m21-2021': 6, 'galaxy-m16': 6, 'galaxy-m14': 6, 'galaxy-m12': 6, 'galaxy-m07': 6,
    'galaxy-m06': 6,
  },
  'Silicone Case': {
    'iphone-17-pro-max': 3, 'iphone-17-pro': 3, 'iphone-17-air': 7, 'iphone-17': 1, 'iphone-17e': 2, 'iphone-16-pro-max': 4,
    'iphone-16-pro': 4, 'iphone-16-plus': 1, 'iphone-16': 1, 'iphone-16e': 2, 'iphone-15-pro-max': 4, 'iphone-15-pro': 4,
    'iphone-15-plus': 2, 'iphone-15': 2, 'iphone-14-pro-max': 4, 'iphone-14-pro': 4, 'iphone-14-plus': 2, 'iphone-14': 2,
    'iphone-13-pro-max': 4, 'iphone-13-pro': 4, 'iphone-13': 2, 'iphone-13-mini': 2, 'iphone-12-pro-max': 4, 'iphone-12-pro': 4,
    'iphone-12': 2, 'iphone-12-mini': 2, 'iphone-11-pro-max': 4, 'iphone-11-pro': 4, 'iphone-11': 2, 'iphone-xs-max': 1,
    'iphone-xs': 1, 'iphone-x': 1, 'iphone-xr': 1, 'iphone-se-2020': 1, 'iphone-8-plus': 2, 'iphone-8': 2,
    'iphone-7-plus': 2, 'iphone-7': 2, 'iphone-6s': 2, 'galaxy-s26-ultra': 6, 'galaxy-s26-plus': 8, 'galaxy-s26': 5,
    'galaxy-s25-ultra': 6, 'galaxy-s25-edge': 5, 'galaxy-s25-plus': 5, 'galaxy-s25': 5, 'galaxy-s24-ultra': 6, 'galaxy-s24-plus': 5,
    'galaxy-s24': 5, 'galaxy-s24-fe': 5, 'galaxy-s23-ultra': 6, 'galaxy-s23-plus': 5, 'galaxy-s23': 5, 'galaxy-s23-fe': 5,
    'galaxy-s22-ultra': 6, 'galaxy-s22-plus': 5, 'galaxy-s22': 5, 'galaxy-s21-ultra': 6, 'galaxy-s21-plus': 5, 'galaxy-s21': 5,
    'galaxy-s21-fe': 5, 'galaxy-s20-ultra': 6, 'galaxy-s20-plus': 5, 'galaxy-s20': 5, 'galaxy-s20-fe': 5, 'galaxy-s10-plus': 5,
    'galaxy-s10': 5, 'galaxy-s10-lite': 5, 'galaxy-s10e': 5, 'galaxy-note-20-ultra': 6, 'galaxy-note-20': 5, 'galaxy-note-10-plus': 5,
    'galaxy-note-10': 5, 'galaxy-note-10-lite': 5, 'galaxy-a91': 5, 'galaxy-a81': 5, 'galaxy-a73': 5, 'galaxy-a72': 5,
    'galaxy-a71': 5, 'galaxy-a57': 5, 'galaxy-a56': 5, 'galaxy-a55': 5, 'galaxy-a54': 5, 'galaxy-a53': 5,
    'galaxy-a52': 5, 'galaxy-a52s': 5, 'galaxy-a51': 5, 'galaxy-a37': 5, 'galaxy-a36': 5, 'galaxy-a35': 5,
    'galaxy-a34': 5, 'galaxy-a33': 5, 'galaxy-a32-5g': 5, 'galaxy-a32-4g': 5, 'galaxy-a27': 5, 'galaxy-a26': 5,
    'galaxy-a23': 5, 'galaxy-a17': 5, 'galaxy-a16': 5, 'galaxy-a14-5g': 5, 'galaxy-a14-4g': 5, 'galaxy-a06': 5,
    'galaxy-f62': 5, 'galaxy-f56': 5, 'galaxy-f55': 5, 'galaxy-f54': 5, 'galaxy-f41': 5, 'galaxy-f36': 5,
    'galaxy-f34': 5, 'galaxy-f23': 5, 'galaxy-f17': 5, 'galaxy-f16': 5, 'galaxy-f15': 5, 'galaxy-f07': 5,
    'galaxy-f06': 5, 'galaxy-m62': 5, 'galaxy-m56': 5, 'galaxy-m55': 5, 'galaxy-m54': 5, 'galaxy-m53': 5,
    'galaxy-m52': 5, 'galaxy-m51': 5, 'galaxy-m36': 5, 'galaxy-m35': 5, 'galaxy-m34': 5, 'galaxy-m33': 5,
    'galaxy-m32': 5, 'galaxy-m31': 5, 'galaxy-m31s': 5, 'galaxy-m30s': 5, 'galaxy-m23': 5, 'galaxy-m21': 5,
    'galaxy-m16': 5, 'galaxy-m15': 5, 'galaxy-m07': 5, 'galaxy-m06': 5,
  },
  'Air Case': {
    'iphone-17-pro-max': 3, 'iphone-17-pro': 3, 'iphone-17-air': 5, 'iphone-17': 1, 'iphone-17e': 8, 'iphone-16-pro-max': 4,
    'iphone-16-pro': 4, 'iphone-16-plus': 1, 'iphone-16': 1, 'iphone-16e': 8, 'iphone-15-pro-max': 4, 'iphone-15-pro': 4,
    'iphone-15-plus': 2, 'iphone-15': 2, 'iphone-14-pro-max': 4, 'iphone-14-pro': 4, 'iphone-14-plus': 2, 'iphone-14': 2,
    'iphone-13-pro-max': 4, 'iphone-13-pro': 4, 'iphone-13': 2, 'iphone-13-mini': 2, 'iphone-12-pro-max': 4, 'iphone-12-pro': 4,
    'iphone-12': 2, 'galaxy-s26-ultra': 7, 'galaxy-s26-plus': 6, 'galaxy-s26': 6, 'galaxy-s25-ultra': 7, 'galaxy-s25-plus': 6,
    'galaxy-s25': 6, 'galaxy-s24-ultra': 7, 'galaxy-s24-plus': 6, 'galaxy-s24': 6, 'galaxy-s23-ultra': 7, 'galaxy-s23-plus': 6,
    'galaxy-s23': 6, 'galaxy-s22-plus': 6, 'galaxy-s22': 6, 'galaxy-s21-ultra': 7, 'galaxy-s21-plus': 6, 'galaxy-s21': 6,
  }
};

// Look up the image index for a model within a specific case type's map. Falls back to 1 (the
// documented "real fallback photo" position, not the blank position-0 placeholder) whenever the
// case type is blank/unrecognized, or the model isn't in that case type's map at all — same
// fallback behavior as before this was split per case type.
function wrapgramImageIndexFor(caseType, model) {
  var map = caseType && WRAPGRAM_IMAGE_MAP[caseType];
  if (!map) return 1;
  return (model && map[model] !== undefined) ? map[model] : 1;
}

// Per-case-type "model NOT available" exclusion sets, keyed by the exact Shopify tag.
// Rebuilt 2026-09-03 from the 5 real exclusion CSVs in docs/Live Phone Models/ (derived from
// actual NextBigE stock data: a model is excluded if it's either not offered at all for that
// case type, or currently out of stock — both treated the same here, since neither can
// currently be fulfilled). Replaces the old hand-maintained GLASS_ONLY/HYBRID_ONLY sets and
// the Air/Flex/Silicone placeholders entirely — not a merge.
var WRAPGRAM_CASE_TYPE_EXCLUSIONS = {
  'Glass Case': new Set([
    'galaxy-s10', 'galaxy-s10e', 'galaxy-a50', 'galaxy-a50s', 'galaxy-a30s', 'galaxy-a12', 'galaxy-f41', 'galaxy-f17',
    'galaxy-f12', 'galaxy-m31', 'galaxy-m31-prime', 'galaxy-m31s', 'galaxy-m12',
  ]),
  'Hybrid Case': new Set([
    'iphone-xs-max', 'iphone-xs', 'iphone-x', 'iphone-xr', 'iphone-8-plus', 'iphone-7-plus', 'iphone-6s-plus', 'iphone-6s',
    'iphone-6-plus', 'iphone-6', 'galaxy-s21-ultra', 'galaxy-s10-plus', 'galaxy-s10', 'galaxy-s10-lite', 'galaxy-s10e', 'galaxy-s9',
    'galaxy-s8-plus', 'galaxy-s8', 'galaxy-note-20', 'galaxy-note-10', 'galaxy-note-10-lite', 'galaxy-a91', 'galaxy-a81', 'galaxy-a72',
    'galaxy-a71', 'galaxy-a70', 'galaxy-a70s', 'galaxy-a55', 'galaxy-a51', 'galaxy-a40', 'galaxy-a40s', 'galaxy-a32-5g',
    'galaxy-a32-4g', 'galaxy-a31', 'galaxy-a23', 'galaxy-a22-5g', 'galaxy-a22-4g', 'galaxy-a12', 'galaxy-a11', 'galaxy-a10',
    'galaxy-a10s', 'galaxy-a05s', 'galaxy-a04', 'galaxy-a03s', 'galaxy-a02s', 'galaxy-f62', 'galaxy-f42', 'galaxy-f22',
    'galaxy-f15', 'galaxy-f12', 'galaxy-f02s', 'galaxy-m62', 'galaxy-m32', 'galaxy-m30', 'galaxy-m23', 'galaxy-m17',
    'galaxy-m15', 'galaxy-m14', 'galaxy-m12', 'galaxy-m11', 'galaxy-m10', 'galaxy-m02s',
  ]),
  'Flex Case': new Set([
    'iphone-17-pro-max', 'iphone-17-pro', 'iphone-16', 'iphone-15-pro-max', 'iphone-15-plus', 'iphone-14-plus', 'iphone-12-pro-max', 'iphone-12-pro',
    'iphone-6s-plus', 'iphone-6s', 'iphone-6-plus', 'iphone-6', 'galaxy-z-fold-7', 'galaxy-z-fold-6', 'galaxy-z-fold-5', 'galaxy-z-fold-4',
    'galaxy-z-fold-3', 'galaxy-z-flip-7', 'galaxy-z-flip-6', 'galaxy-z-flip-5', 'galaxy-z-flip-4', 'galaxy-z-flip-3', 'galaxy-s24-ultra', 'galaxy-s22-ultra',
    'galaxy-s20-ultra', 'galaxy-s20-plus', 'galaxy-s20', 'galaxy-s10e', 'galaxy-s9', 'galaxy-s8-plus', 'galaxy-s8', 'galaxy-note-10',
    'galaxy-a72', 'galaxy-a70', 'galaxy-a70s', 'galaxy-a54', 'galaxy-a40', 'galaxy-a40s', 'galaxy-a34', 'galaxy-a33',
    'galaxy-a32-5g', 'galaxy-a32-4g', 'galaxy-a11', 'galaxy-a10', 'galaxy-a10s', 'galaxy-a05s', 'galaxy-a04', 'galaxy-a03s',
    'galaxy-a02s', 'galaxy-f02s', 'galaxy-m30', 'galaxy-m17', 'galaxy-m15', 'galaxy-m11', 'galaxy-m10', 'galaxy-m02s',
  ]),
  'Silicone Case': new Set([
    'iphone-se-2022', 'iphone-6s-plus', 'iphone-6-plus', 'iphone-6', 'galaxy-z-fold-7', 'galaxy-z-fold-6', 'galaxy-z-fold-5', 'galaxy-z-fold-4',
    'galaxy-z-fold-3', 'galaxy-z-flip-7', 'galaxy-z-flip-6', 'galaxy-z-flip-5', 'galaxy-z-flip-4', 'galaxy-z-flip-3', 'galaxy-s25-plus', 'galaxy-s25-fe',
    'galaxy-s20-plus', 'galaxy-s9', 'galaxy-s8-plus', 'galaxy-s8', 'galaxy-note-20-ultra', 'galaxy-note-20', 'galaxy-note-10-plus', 'galaxy-note-10',
    'galaxy-note-10-lite', 'galaxy-a81', 'galaxy-a73', 'galaxy-a72', 'galaxy-a70', 'galaxy-a70s', 'galaxy-a52', 'galaxy-a52s',
    'galaxy-a50', 'galaxy-a50s', 'galaxy-a40', 'galaxy-a40s', 'galaxy-a31', 'galaxy-a30s', 'galaxy-a27', 'galaxy-a26',
    'galaxy-a25', 'galaxy-a22-5g', 'galaxy-a22-4g', 'galaxy-a15', 'galaxy-a12', 'galaxy-a11', 'galaxy-a10', 'galaxy-a10s',
    'galaxy-a05s', 'galaxy-a04', 'galaxy-a03s', 'galaxy-a02s', 'galaxy-f62', 'galaxy-f54', 'galaxy-f42', 'galaxy-f41',
    'galaxy-f23', 'galaxy-f22', 'galaxy-f14', 'galaxy-f12', 'galaxy-f02s', 'galaxy-m62', 'galaxy-m54', 'galaxy-m53',
    'galaxy-m33', 'galaxy-m31', 'galaxy-m31-prime', 'galaxy-m31s', 'galaxy-m30', 'galaxy-m30s', 'galaxy-m23', 'galaxy-m21',
    'galaxy-m21-2021', 'galaxy-m17', 'galaxy-m14', 'galaxy-m12', 'galaxy-m11', 'galaxy-m10', 'galaxy-m02s',
  ]),
  'Air Case': new Set([
    'iphone-se-2022', 'iphone-12-mini', 'iphone-11-pro-max', 'iphone-11-pro', 'iphone-11', 'iphone-xs-max', 'iphone-xs', 'iphone-x',
    'iphone-xr', 'iphone-se-2020', 'iphone-8-plus', 'iphone-8', 'iphone-7-plus', 'iphone-7', 'iphone-6s-plus', 'iphone-6s',
    'iphone-6-plus', 'iphone-6', 'galaxy-z-fold-7', 'galaxy-z-fold-6', 'galaxy-z-fold-5', 'galaxy-z-fold-4', 'galaxy-z-fold-3', 'galaxy-z-flip-7',
    'galaxy-z-flip-6', 'galaxy-z-flip-5', 'galaxy-z-flip-4', 'galaxy-z-flip-3', 'galaxy-s25-edge', 'galaxy-s25-fe', 'galaxy-s24-fe', 'galaxy-s23-fe',
    'galaxy-s22-ultra', 'galaxy-s21-fe', 'galaxy-s20-ultra', 'galaxy-s20-plus', 'galaxy-s20', 'galaxy-s20-fe', 'galaxy-s10-plus', 'galaxy-s10',
    'galaxy-s10-lite', 'galaxy-s10e', 'galaxy-s9', 'galaxy-s8-plus', 'galaxy-s8', 'galaxy-note-20-ultra', 'galaxy-note-20', 'galaxy-note-10-plus',
    'galaxy-note-10', 'galaxy-note-10-lite', 'galaxy-a91', 'galaxy-a81', 'galaxy-a73', 'galaxy-a72', 'galaxy-a71', 'galaxy-a70',
    'galaxy-a70s', 'galaxy-a57', 'galaxy-a56', 'galaxy-a55', 'galaxy-a54', 'galaxy-a53', 'galaxy-a52', 'galaxy-a52s',
    'galaxy-a51', 'galaxy-a50', 'galaxy-a50s', 'galaxy-a40', 'galaxy-a40s', 'galaxy-a37', 'galaxy-a36', 'galaxy-a35',
    'galaxy-a34', 'galaxy-a33', 'galaxy-a32-5g', 'galaxy-a32-4g', 'galaxy-a31', 'galaxy-a30s', 'galaxy-a27', 'galaxy-a26',
    'galaxy-a25', 'galaxy-a23', 'galaxy-a22-5g', 'galaxy-a22-4g', 'galaxy-a17', 'galaxy-a16', 'galaxy-a15', 'galaxy-a14-5g',
    'galaxy-a14-4g', 'galaxy-a12', 'galaxy-a11', 'galaxy-a10', 'galaxy-a10s', 'galaxy-a06', 'galaxy-a05s', 'galaxy-a04',
    'galaxy-a03s', 'galaxy-a02s', 'galaxy-f62', 'galaxy-f56', 'galaxy-f55', 'galaxy-f54', 'galaxy-f42', 'galaxy-f41',
    'galaxy-f36', 'galaxy-f34', 'galaxy-f23', 'galaxy-f22', 'galaxy-f17', 'galaxy-f16', 'galaxy-f15', 'galaxy-f14',
    'galaxy-f12', 'galaxy-f07', 'galaxy-f06', 'galaxy-f02s', 'galaxy-m62', 'galaxy-m56', 'galaxy-m55', 'galaxy-m54',
    'galaxy-m53', 'galaxy-m52', 'galaxy-m51', 'galaxy-m36', 'galaxy-m35', 'galaxy-m34', 'galaxy-m33', 'galaxy-m32',
    'galaxy-m31', 'galaxy-m31-prime', 'galaxy-m31s', 'galaxy-m30', 'galaxy-m30s', 'galaxy-m23', 'galaxy-m21', 'galaxy-m21-2021',
    'galaxy-m17', 'galaxy-m16', 'galaxy-m15', 'galaxy-m14', 'galaxy-m12', 'galaxy-m11', 'galaxy-m10', 'galaxy-m07',
    'galaxy-m06', 'galaxy-m02s',
  ])
};

function wrapgramInitInfiniteScroll() { /* placeholder — pagination in use */ }

// ─── Case-type filter + disabled pills ───────────────────────────────────────

// Disable incompatible pills and optionally redirect to the correct tag-filtered URL.
// trigger values:
//   'model' — user just changed their device (context-changed event)
//             → restricted models navigate to their filter; both-supported resets to All
//   'page'  — page loaded with a model already in localStorage (DOMContentLoaded)
//             → restricted models navigate to their filter; both-supported respects
//               any manually-set filter the user chose (no reset to All)
//   falsy   — no navigation (MutationObserver, cross-tab storage sync)

// --- Composite avail-* tags: resolve a model's real combination of valid case types,
// backed by the Device Case Compatibility metaobject (window.WrapgramDeviceCompatibility,
// emitted in theme.liquid). Tag names are canonical — same fixed order every time — so they
// match whatever the catalog's own avail-* product tags were built with.
var WRAPGRAM_AVAIL_CASE_ORDER = ['glass_case', 'hybrid_case', 'flex_case', 'silicone_case', 'air_case'];
var WRAPGRAM_AVAIL_CASE_WORD = {
  glass_case: 'glass',
  hybrid_case: 'hybrid',
  flex_case: 'flex',
  silicone_case: 'silicone',
  air_case: 'air'
};

function wrapgramAvailTagFor(model) {
  var compat = window.WrapgramDeviceCompatibility && window.WrapgramDeviceCompatibility[model];
  if (!compat) return null;
  var words = [];
  WRAPGRAM_AVAIL_CASE_ORDER.forEach(function(key) {
    if (compat[key]) words.push(WRAPGRAM_AVAIL_CASE_WORD[key]);
  });
  return words.length ? 'avail-' + words.join('-') : null;
}

// Every design collection whose products carry avail-* tags (see docs/Live Phone Models/
// 06-09-2026_Availability Tag Definitions.csv). Verified against the live catalog 2026-09-15 —
// these 38 handles' product counts sum to exactly 2,015, the full catalog, with zero gaps or
// overlap. A collection not in this list is left completely alone by the code below, so this
// can never redirect anyone into an empty grid — keep this in sync if new designs are added.
var WRAPGRAM_AVAIL_TAGGED_COLLECTIONS = [
  'anime-attack-on-titan', 'anime-black-clover', 'anime-bleach', 'anime-chainsaw-man',
  'anime-dan-dan', 'anime-death-note', 'anime-demon-slayer', 'anime-dragon-ball',
  'anime-fma-brotherhood', 'anime-hunter-x-hunter', 'anime-jojo', 'anime-jujutsu-kaisen',
  'anime-my-hero-academia', 'anime-naruto', 'anime-one-piece', 'anime-one-punch-man',
  'anime-solo-leveling', 'anime-tokyo-ghoul',
  'superhero-avengers', 'superhero-batman', 'superhero-deadpool', 'superhero-iron-man',
  'superhero-joker', 'superhero-spider-man', 'superhero-thor', 'superhero-venom',
  'superhero-captain-america', 'superhero-justice-league',
  'generic-sacred-protective', 'generic-luxe', 'generic-my-vibe', 'generic-daily-motivation',
  'generic-simply-beautiful', 'generic-cute-quirky', 'generic-dreamscape', 'generic-retro-feels',
  'generic-aesthetic-edit', 'generic-unapologetic'
];

// The top-level category collections (design-selection page's "View all →" links, and
// /collections/anime|superhero|generic directly), plus the catalog-wide "all" collection added
// 2026-10-12 for the case-type tiles. Kept separate from the 38 design handles above so that
// array's own "sums to 2,015 with zero overlap" invariant stays true and checkable — these are
// supersets of it, not additional members. Verified 2026-09-16: anime/superhero/generic's product
// counts exactly equal the sum of their own sub-designs already in WRAPGRAM_AVAIL_TAGGED_COLLECTIONS
// (201 + 168 + 1,646 = the full 2,015-product catalog with zero overlap); "all" is a smart
// collection matching every product (vendor = Wrapgram), so it's the same full set again. Found
// missing 2026-09-16: "View all" landed on an unfiltered grid because neither this gate nor the
// tile-href logic below recognized these handles as avail-tag-safe.
var WRAPGRAM_AVAIL_TAGGED_TOP_LEVEL_COLLECTIONS = ['anime', 'superhero', 'generic', 'all'];

function wrapgramIsAvailTaggedCollection(handle) {
  return WRAPGRAM_AVAIL_TAGGED_COLLECTIONS.indexOf(handle) !== -1 ||
    WRAPGRAM_AVAIL_TAGGED_TOP_LEVEL_COLLECTIONS.indexOf(handle) !== -1;
}

var WRAPGRAM_CASE_TYPE_TO_KEY = {
  'Glass Case': 'glass_case',
  'Hybrid Case': 'hybrid_case',
  'Flex Case': 'flex_case',
  'Silicone Case': 'silicone_case',
  'Air Case': 'air_case'
};
var WRAPGRAM_KEY_TO_CASE_TYPE = {
  glass_case: 'Glass Case',
  hybrid_case: 'Hybrid Case',
  flex_case: 'Flex Case',
  silicone_case: 'Silicone Case',
  air_case: 'Air Case'
};

// Product-page compatibility cascade — the direct-link scenario: a visitor lands on a specific
// product with no (or a different) device context, then selects one that this exact product
// doesn't support. The design handle comes straight from main-product.liquid's (now-fixed)
// wrapgram_design_cat computation — generic for any product, no per-design lookup table needed.
// Still pilot-gated by WRAPGRAM_AVAIL_TAGGED_COLLECTIONS below, since that's a question of which
// designs' products actually carry avail-* tags yet, not a question of identifying the design.
function wrapgramHandleProductCompatibility(model) {
  if (!model) return;

  var designEl = document.querySelector('[data-wrapgram-product-design-handle]');
  var caseTypeEl = document.querySelector('[data-wrapgram-product-case-type]');
  if (!designEl || !caseTypeEl) return; // not a product page, or markers missing

  var handle = designEl.getAttribute('data-wrapgram-product-design-handle');
  var caseType = caseTypeEl.getAttribute('data-wrapgram-product-case-type');
  if (!handle || !caseType) return;

  if (WRAPGRAM_AVAIL_TAGGED_COLLECTIONS.indexOf(handle) === -1) return; // this design isn't in pilot scope yet

  var compat = window.WrapgramDeviceCompatibility && window.WrapgramDeviceCompatibility[model];
  if (!compat) return;

  var key = WRAPGRAM_CASE_TYPE_TO_KEY[caseType];
  if (!key || compat[key]) return; // still compatible — nothing to do

  var validKeys = WRAPGRAM_AVAIL_CASE_ORDER.filter(function(k) { return compat[k]; });
  if (!validKeys.length) return;

  // Tier 1 — the exact same design, same product family, just a different (valid) case type.
  // E.g. landing on "Nine Tails Fury Silicone Case" with a device that only supports Hybrid
  // redirects straight to "Nine Tails Fury Hybrid Case", not just a filtered list that happens
  // to contain it. Tried first, regardless of how many case types are valid.
  var siblingsEl = document.querySelector('[data-wrapgram-product-siblings]');
  var siblings = {};
  if (siblingsEl) {
    try {
      siblings = JSON.parse(siblingsEl.getAttribute('data-wrapgram-product-siblings') || '{}');
    } catch (e) {
      siblings = {};
    }
  }
  for (var i = 0; i < validKeys.length; i++) {
    var siblingHandle = siblings[WRAPGRAM_KEY_TO_CASE_TYPE[validKeys[i]]];
    if (siblingHandle) {
      window.location = '/products/' + siblingHandle;
      return;
    }
  }

  // Tier 2 — no matching sibling product exists; fall back to the design's own collection,
  // filtered to what's actually available. Guarded by Tier 3 below for designs that don't stock
  // ANY of this device's valid case types at all — e.g. Dan Dan/JoJo only carry Glass + Hybrid.
  // That was unreachable while only Naruto (full 5-type coverage) was in scope; confirmed
  // 2026-09-15, once the whitelist went site-wide, that it's a real gap for smaller designs.
  var designTypesEl = document.querySelector('[data-wrapgram-design-case-types]');
  var designCaseTypes = [];
  if (designTypesEl) {
    try {
      designCaseTypes = JSON.parse(designTypesEl.getAttribute('data-wrapgram-design-case-types') || '[]');
    } catch (e) {
      designCaseTypes = [];
    }
  }
  var designKeys = designCaseTypes.map(function(t) { return WRAPGRAM_CASE_TYPE_TO_KEY[t]; }).filter(Boolean);
  var hasOverlap = validKeys.some(function(k) { return designKeys.indexOf(k) !== -1; });

  // Tier 3 — this design stocks none of the case types valid for this device: no sibling exists,
  // and a Tier-2 redirect would land on a real collection page with zero products in it (worse
  // than doing nothing). Escalate to the design-selection page instead — it already reads the
  // device from localStorage and only ever surfaces designs/case types that exist for it.
  if (!hasOverlap) {
    window.location = '/pages/design-selection';
    return;
  }

  var destUrl;
  if (validKeys.length === 1) {
    destUrl = '/collections/' + handle + '/' + WRAPGRAM_AVAIL_CASE_WORD[validKeys[0]] + '-case';
  } else {
    var availTag = wrapgramAvailTagFor(model);
    if (!availTag) return;
    destUrl = '/collections/' + handle + '/' + availTag;
  }

  window.location = destUrl;
}

// Moves disabled case-type pills (wrapgram-filter-pill--disabled, set below) to the end of the
// row instead of leaving them in their fixed schema-block position — a disabled type sitting
// 2nd of 6 reads as a hole in the row; sorted last it reads as "not for you" instead. appendChild
// on an already-attached node moves it, so iterating available-then-disabled in original relative
// order and re-appending each reconstructs exactly that sequence (a stable sort, not a shuffle).
// window.wrapgramPositionCasePillIndicator is defined in sections/wrapgram-collection-filter.liquid
// (that's where the indicator element itself lives) — called here so the sliding white indicator
// never lags behind a reorder it didn't know happened.
function wrapgramReorderCaseFilterPills(filterWrap) {
  var pills = Array.prototype.slice.call(filterWrap.querySelectorAll('[data-filter-tag]'));
  var available = pills.filter(function(p) { return !p.classList.contains('wrapgram-filter-pill--disabled'); });
  var disabled = pills.filter(function(p) { return p.classList.contains('wrapgram-filter-pill--disabled'); });
  available.concat(disabled).forEach(function(p) { filterWrap.appendChild(p); });
  if (window.wrapgramPositionCasePillIndicator) window.wrapgramPositionCasePillIndicator();
}

function wrapgramApplyCaseTypeFilter(model, trigger) {
  var filterWrap = document.getElementById('wrapgram-case-filter');
  if (!filterWrap) return;

  if (!model) {
    filterWrap.querySelectorAll('[data-filter-tag]').forEach(function(p) {
      p.classList.remove('wrapgram-filter-pill--disabled');
    });
    wrapgramReorderCaseFilterPills(filterWrap);
    return;
  }

  var pills = filterWrap.querySelectorAll('[data-filter-tag]');

  // Disable incompatible pills — data-driven across all 5 case types via
  // WRAPGRAM_CASE_TYPE_EXCLUSIONS (real data for all 5, not placeholders).
  var excludedTags = [];
  var availableTags = [];
  pills.forEach(function(pill) {
    var tag = pill.getAttribute('data-filter-tag');
    var exclusions = WRAPGRAM_CASE_TYPE_EXCLUSIONS[tag];
    var isExcluded = exclusions ? exclusions.has(model) : false;
    pill.classList.toggle('wrapgram-filter-pill--disabled', isExcluded);
    (isExcluded ? excludedTags : availableTags).push(tag);
  });
  wrapgramReorderCaseFilterPills(filterWrap);

  if (!trigger) return;

  var handle = filterWrap.getAttribute('data-collection-handle');
  if (!handle) return;

  // rawUrlTag (the whole path segment, untouched) still gates the `!rawUrlTag` branch below,
  // exactly as before — that's what's actually safe to treat as "no tag in the URL at all"
  // (pathParts[3] missing entirely). currentUrlTag ('+'-split, avail- parts filtered out) is a
  // SEPARATE value used further down only for matching a pill's plain data-filter-url-tag.
  // Collapsing these into one variable (an earlier version of this fix did exactly that) broke a
  // real, different case: a pure avail-tag URL with no case type chosen (e.g.
  // /collections/handle/avail-iphone16) has a non-empty rawUrlTag but, once avail- parts are
  // filtered, an EMPTY currentUrlTag — if that same stripped value also gated `!currentUrlTag`,
  // the page treated "device-filtered, no case type" as "bare All view" and re-ran the avail-tag
  // redirect below against a collection it was ALREADY on, on every single page load — a
  // continuous redirect loop (caught live 2026-10-21, right after the first version of this
  // fix shipped).
  var pathParts = window.location.pathname.replace(/\/$/, '').split('/');
  var rawUrlTag = pathParts[3] || '';
  var urlTagParts = rawUrlTag.split('+').filter(Boolean);
  var currentUrlTag = urlTagParts.filter(function(t) { return t.indexOf('avail-') !== 0; })[0] || '';

  if (!rawUrlTag) {
    // "All" view. Two situations actually filter the grid from here:
    //  - exactly one valid case type: redirect straight to that type's own plain tag URL (e.g.
    //    /collections/{handle}/silicone-case). Works everywhere, not just pilot designs, since it
    //    only needs the case-type tag every product already carries — restores behavior the old
    //    WRAPGRAM_HYBRID_ONLY_MODELS/WRAPGRAM_GLASS_ONLY_MODELS code had that was lost in the
    //    multi-case-type rewrite (regression found + fixed 2026-09-16).
    //  - 2+ valid case types on an avail-tagged collection (design or top-level — see
    //    wrapgramIsAvailTaggedCollection): redirect to the avail-* composite tag URL for the
    //    exact combination this model needs. Widened to include the 3 top-level category
    //    collections 2026-09-16 — "View all" from the design-selection page (and any direct visit
    //    to /collections/anime|superhero|generic) landed on an unfiltered grid otherwise, since
    //    those handles were never in WRAPGRAM_AVAIL_TAGGED_COLLECTIONS (by design — see that
    //    array's own comment), even though every product in them already carries avail-* tags.
    // Everywhere else (2+ valid types, some other non-tagged collection) there's no single
    // correct destination grid yet, so it falls through unchanged rather than guessing.
    if (availableTags.length === 1) {
      var onlyPill = filterWrap.querySelector('[data-filter-tag="' + availableTags[0] + '"]');
      var onlyUrl = onlyPill ? onlyPill.getAttribute('data-filter-url') : '';
      if (onlyUrl) {
        var onlySortBy = new URLSearchParams(window.location.search).get('sort_by');
        if (onlySortBy) onlyUrl += (onlyUrl.indexOf('?') === -1 ? '?' : '&') + 'sort_by=' + encodeURIComponent(onlySortBy);
        window.location = onlyUrl;
        return;
      }
    } else if (availableTags.length > 1 && wrapgramIsAvailTaggedCollection(handle)) {
      var availTag = wrapgramAvailTagFor(model);
      if (availTag) {
        var availUrl = '/collections/' + handle + '/' + availTag;
        var availSortBy = new URLSearchParams(window.location.search).get('sort_by');
        if (availSortBy) availUrl += '?sort_by=' + encodeURIComponent(availSortBy);
        window.location = availUrl;
        return;
      }
    }
    return; // no single destination applies here yet
  }

  var currentPill = null;
  pills.forEach(function(pill) {
    if (pill.getAttribute('data-filter-url-tag') === currentUrlTag) currentPill = pill;
  });
  var currentTag = currentPill ? currentPill.getAttribute('data-filter-tag') : null;
  var currentIsExcluded = currentTag ? excludedTags.indexOf(currentTag) !== -1 : false;

  // destPill stays null to mean "redirect to All".
  var destPill = null;
  if (currentIsExcluded) {
    // The view the customer is on doesn't support this model at all — must move. Go straight to
    // the one remaining option if there's exactly one; with several still valid there's no single
    // obvious destination, so fall back to All.
    if (availableTags.length === 1) {
      destPill = filterWrap.querySelector('[data-filter-tag="' + availableTags[0] + '"]');
    }
  } else {
    // Current view still supports this model.
    if (trigger === 'page') return; // respect the customer's manual pick, don't override on page load
    // trigger === 'model': device just changed.
    if (availableTags.length === 1) {
      if (currentTag === availableTags[0]) return; // already on the single correct filter
      destPill = filterWrap.querySelector('[data-filter-tag="' + availableTags[0] + '"]');
    }
    // else: multiple valid options remain — fall through to redirect to All (destPill stays null),
    // matching the original both-supported-resets-to-All behavior on an explicit device switch.
  }

  // Recombine with a FRESH avail-tag computed for the NEW model — not the old URL's avail-tag
  // (which described the PREVIOUS device and may no longer be accurate for this one), and not
  // dropped entirely (the bug currentUrlTag's own note above describes). Mirrors the exact
  // tag-combining + alphabetical-sort convention sections/wrapgram-collection-filter.liquid's own
  // buildUrl() uses, so both land on the same canonical URL Shopify would otherwise 301 to anyway.
  var destAvailTag = wrapgramIsAvailTaggedCollection(handle) ? wrapgramAvailTagFor(model) : '';
  var url;
  if (destPill) {
    var destCaseUrlTag = destPill.getAttribute('data-filter-url-tag');
    var destTags = destAvailTag ? [destAvailTag, destCaseUrlTag].sort() : [destCaseUrlTag];
    url = '/collections/' + handle + '/' + destTags.join('+');
  } else if (destAvailTag) {
    url = '/collections/' + handle + '/' + destAvailTag;
  } else {
    url = '/collections/' + handle;
  }
  var sortBy = new URLSearchParams(window.location.search).get('sort_by');
  if (sortBy) url += (url.indexOf('?') === -1 ? '?' : '&') + 'sort_by=' + encodeURIComponent(sortBy);
  window.location = url;
}

// --- Scenario 2: Collection banner for no-context collection page visits ---
function wrapgramInjectCollectionBanner() {
  var grid = document.getElementById('ProductGridContainer');
  if (!grid) return;
  if (localStorage.getItem('wrapgram_model')) return;
  if (document.getElementById('wrapgram-collection-banner')) return;

  var banner = document.createElement('div');
  banner.id = 'wrapgram-collection-banner';
  banner.style.cssText = 'margin:0 0 20px;padding:12px 16px;background:#f5f5f5;border-radius:8px;display:flex;align-items:center;justify-content:space-between;gap:12px;flex-wrap:wrap;';
  banner.innerHTML =
    '<span style="font-size:0.88rem;color:#333;font-weight:500;">Select your phone to see cases that fit your device</span>' +
    '<button type="button" style="flex-shrink:0;padding:8px 16px;background:#111;color:#fff;border:none;border-radius:7px;font-size:0.85rem;font-weight:600;cursor:pointer;white-space:nowrap;">Select Phone &#8594;</button>';

  banner.addEventListener('click', function() {
    if (window.openWrapgramDeviceSelector) window.openWrapgramDeviceSelector();
  });

  // Insert before #ProductGridContainer so Dawn's facet AJAX (which replaces its contents) never wipes the banner
  grid.insertAdjacentElement('beforebegin', banner);
}

function wrapgramRemoveCollectionBanner() {
  var el = document.getElementById('wrapgram-collection-banner');
  if (el) el.remove();
}

// --- Scenario 1: In-page CTA for no-context product page visits ---
function wrapgramInjectProductCTA() {
  var titleContainer = document.querySelector('.product__title');
  if (!titleContainer) return;
  if (localStorage.getItem('wrapgram_model')) return;
  if (document.getElementById('wrapgram-product-cta')) return;

  var cta = document.createElement('div');
  cta.id = 'wrapgram-product-cta';
  cta.style.cssText = 'margin:12px 0 20px;';
  cta.innerHTML =
    '<button type="button" style="width:100%;padding:14px 20px;background:#111;color:#fff;border:none;border-radius:10px;font-size:0.95rem;font-weight:700;cursor:pointer;text-align:left;display:flex;align-items:center;justify-content:space-between;gap:8px;">' +
    '<span>See how this looks on your phone</span>' +
    '<span style="font-size:1.1rem;">&#8594;</span>' +
    '</button>' +
    '<p style="margin:6px 0 0;font-size:0.78rem;color:#888;text-align:center;">Pick your model &middot; We\'ll show the exact layout for your device</p>';

  cta.addEventListener('click', function() {
    if (window.openWrapgramDeviceSelector) window.openWrapgramDeviceSelector();
  });

  titleContainer.insertAdjacentElement('afterend', cta);
}

function wrapgramRemoveProductCTA() {
  var el = document.getElementById('wrapgram-product-cta');
  if (el) el.remove();
}

// --- Shared helpers ---
function wrapgramGetDisplayName(brand, model) {
  if (!model) return '';
  var brands = (window.WrapgramConfig && window.WrapgramConfig.brands) || [];
  var brandObj = brands.find(function(b) { return b.id === brand; });
  if (brandObj) {
    var modelObj = brandObj.models.find(function(m) { return m.id === model; });
    if (modelObj) return modelObj.display_name;
  }
  return model;
}

// overrideBrand/overrideModel: optional — used by the wishlist page so an add-to-cart carries
// the device that was active when the item was saved, not whatever's currently selected
// site-wide. Every existing caller omits these and falls back to localStorage exactly as before.
function wrapgramAddToCart(variantId, quantity, imageUrl, isBuyNow, btn, overrideBrand, overrideModel) {
  var brand = overrideBrand || localStorage.getItem('wrapgram_brand') || '';
  var model = overrideModel || localStorage.getItem('wrapgram_model') || '';
  var displayName = wrapgramGetDisplayName(brand, model);
  var label, origText;
  if (btn) {
    label = btn.querySelector('.wrapgram-card-btn__label') || btn;
    origText = label.textContent;
    btn.disabled = true;
    label.textContent = '…';
  }

  // On the cart page itself, also ask for the line-items/footer sections so adding a recommended
  // case from the cart's own cross-sell strip actually updates what's already on screen instead of
  // needing a reload — previously this function only ever requested the notification-popup
  // sections, so an add from inside /cart left the line-items table and totals stale. Harmless
  // elsewhere: cart-notification's renderContents() only ever reads the 3 section ids it already
  // knows about and ignores anything extra in the response, and these two elements simply don't
  // exist outside the cart page.
  var sections = ['cart-notification-product', 'cart-notification-button', 'cart-icon-bubble'];
  var cartItemsEl = document.getElementById('main-cart-items');
  var cartFooterEl = document.getElementById('main-cart-footer');
  if (cartItemsEl && cartItemsEl.dataset.id) sections.push(cartItemsEl.dataset.id);
  if (cartFooterEl && cartFooterEl.dataset.id) sections.push(cartFooterEl.dataset.id);

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id: variantId,
      quantity: quantity || 1,
      properties: {
        '_wrapgram_brand': brand,
        '_wrapgram_model': model,
        '_model': displayName,
        '_uid': Date.now() + '-' + Math.random().toString(36).slice(2, 7),
        '_image_url': imageUrl,
        'Model': displayName
      },
      sections: sections
    })
  })
  .then(function(r) { return r.json().then(function(data) { return { ok: r.ok, data: data }; }); })
  .then(function(result) {
    // Shopify's /cart/add.js returns a non-2xx status with an error-shaped body (e.g. sold out,
    // quantity exceeds available inventory) rather than rejecting the fetch — checking r.ok was
    // previously missing entirely, so a failed add was treated identically to a successful one.
    // For Buy Now specifically that meant redirecting straight to checkout with nothing actually
    // in the cart, and no indication anything went wrong.
    if (!result.ok) {
      if (btn) { btn.disabled = false; if (label) label.textContent = origText; }
      alert((result.data && (result.data.description || result.data.message)) || 'Could not add this item to your cart. Please try again.');
      return;
    }
    var data = result.data;
    if (isBuyNow) {
      // Gated the same way as the cart's Checkout button (assets/wrapgram-login-session.js) —
      // item is already added to the real cart above either way, so if login is needed the item
      // isn't lost; they land back here with it still in cart after logging in.
      if (window.wrapgramRequireLogin) { window.wrapgramRequireLogin('/checkout'); }
      else { window.location.href = '/checkout'; }
    } else {
      if (btn) { btn.disabled = false; label.textContent = origText; }
      var cartNotification = document.querySelector('cart-notification');
      if (cartNotification && data.sections) cartNotification.renderContents(data);

      // Cart page: swap in the fresh line-items/footer HTML — same .js-contents technique Dawn's
      // own cart.js already uses for quantity/remove changes — then publish the same cart-update
      // event that flow already fires, so every existing listener (the cart cross-sell section's
      // own refresh included) reacts exactly as it already does to a quantity change, with no
      // special-casing needed there.
      if (cartItemsEl && data.sections && data.sections[cartItemsEl.dataset.id]) {
        var itemsFresh = new DOMParser().parseFromString(data.sections[cartItemsEl.dataset.id], 'text/html').querySelector('.js-contents');
        var itemsTarget = cartItemsEl.querySelector('.js-contents') || cartItemsEl;
        if (itemsFresh) itemsTarget.innerHTML = itemsFresh.innerHTML;
      }
      if (cartFooterEl && data.sections && data.sections[cartFooterEl.dataset.id]) {
        var footerFresh = new DOMParser().parseFromString(data.sections[cartFooterEl.dataset.id], 'text/html').querySelector('.js-contents');
        var footerTarget = cartFooterEl.querySelector('.js-contents') || cartFooterEl;
        if (footerFresh) footerTarget.innerHTML = footerFresh.innerHTML;
      }
      if ((cartItemsEl || cartFooterEl) && typeof publish === 'function' && window.PUB_SUB_EVENTS) {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'wrapgram-add-to-cart', cartData: data });
      }
    }
  })
  .catch(function() {
    if (btn) { btn.disabled = false; if (label) label.textContent = origText; }
  });
}

function wrapgramPersonalize() {
  // Dawn theme: product title is <div class="product__title"><h1>...</h1></div>
  var titleContainer = document.querySelector('.product__title');
  var h1 = titleContainer ? titleContainer.querySelector('h1') : null;
  var isProductPage = !!h1;

  var model = localStorage.getItem('wrapgram_model');
  var brand = localStorage.getItem('wrapgram_brand');

  var caseTypeEl = document.querySelector('[data-wrapgram-product-case-type]');
  var caseType = caseTypeEl ? caseTypeEl.getAttribute('data-wrapgram-product-case-type') : '';
  var idx = wrapgramImageIndexFor(caseType, model);

  // --- Switch product gallery image — runs even with no model selected. Position 1 is a blank
  // checkout-only placeholder now, never a real default, so the gallery still needs to swap onto
  // index 1 (the real fallback photo) instead of leaving Shopify's own server-rendered "featured
  // media" (position 1) showing.
  if (isProductPage) {
    var slider = document.querySelector('[id^="Slider-Gallery-"]');
    if (slider) {
      var slides = slider.querySelectorAll('li.product__media-item');
      var target = Math.min(idx, slides.length - 1);
      slides.forEach(function(slide, i) {
        if (i === target) {
          slide.style.display = '';
          slide.classList.add('is-active');
          // Load deferred image now — set src from data-src
          var img = slide.querySelector('img[data-wrapgram-deferred]');
          if (img && img.getAttribute('data-src')) {
            img.src = img.getAttribute('data-src');
            img.srcset = img.getAttribute('data-srcset') || '';
            img.removeAttribute('data-src');
            img.removeAttribute('data-srcset');
            img.removeAttribute('data-wrapgram-deferred');
          }
        } else {
          slide.style.display = 'none';
          slide.classList.remove('is-active');
        }
      });
    }
  }

  // --- Update product title (only meaningful once a device is actually selected) ---
  if (model && isProductPage && h1) {
    var orig = h1.getAttribute('data-wrapgram-orig') || h1.textContent.trim();
    h1.setAttribute('data-wrapgram-orig', orig);

    var displayName = wrapgramGetDisplayName(brand, model) || model;
    var suffix = ' for ' + displayName;
    if (h1.textContent.indexOf(suffix) === -1) {
      h1.textContent = orig + suffix;
    }
    // BUG-6: Dawn also renders an h2.h1 inside .product__title (quick-view context)
    var h2 = titleContainer.querySelector('h2');
    if (h2) {
      var orig2 = h2.getAttribute('data-wrapgram-orig') || h2.textContent.trim();
      h2.setAttribute('data-wrapgram-orig', orig2);
      if (h2.textContent.indexOf(suffix) === -1) h2.textContent = orig2 + suffix;
    }
  }

}

// --- Swap collection card images + update titles ---
function wrapgramPersonalizeCards() {
  var model = localStorage.getItem('wrapgram_model');
  var brand = localStorage.getItem('wrapgram_brand');
  if (!model) return;

  var displayName = wrapgramGetDisplayName(brand, model) || model;
  document.querySelectorAll('img[data-wrapgram-product-card]').forEach(function(img) {
    // Hoisted once per card and reused below — case type for the image-index lookup, card element
    // for the model-line text update.
    var card = img.closest('[data-wrapgram-card]');

    // Cards not yet revealed (still showing the placeholder, waiting for
    // wrapgramCardImageObserver to bring them into view) don't need updating here — when they do get
    // revealed, wrapgramRevealCardImage() reads localStorage fresh and picks the correct image directly.
    // Touching them now would force an early fetch, defeating the point of deferring them.
    if (!img.hasAttribute('data-wrapgram-card-deferred')) {
      var raw = img.getAttribute('data-wrapgram-media');
      if (raw) {
        // Read per-card, not once for the whole grid — a mixed "All" filter view can show
        // Glass/Hybrid/Flex/Silicone/Air cards side by side, each needing its own case type's map.
        var caseType = card ? card.getAttribute('data-wrapgram-case-type') : '';
        var idx = wrapgramImageIndexFor(caseType, model);
        var urls = raw.split('|');
        var target = Math.min(idx, urls.length - 1);
        // img.src always reads back as an absolute URL, but data-wrapgram-media (built from Shopify's
        // image_url filter) is protocol-relative ("//cdn..."). Comparing them as raw strings never
        // matches even when they're the same image, so resolve urls[target] the same way the DOM
        // resolves img.src before comparing — otherwise this guard silently never fires.
        if (urls[target]) {
          var resolvedTarget = new URL(urls[target], window.location.href).href;
          if (img.src !== resolvedTarget) {
            // Order matters here. srcset (whether it's still Shopify's original server-rendered
            // multi-candidate set, or a single-candidate one from an earlier pass of this same
            // function) always references whichever image was current BEFORE this swap. Clearing it
            // first, then setting src, means there's never a moment where src and srcset point at two
            // different devices' images — that mismatch is what was causing the browser to kick off
            // an extra, avoidable fetch for the previous image on every swap.
            if (img.hasAttribute('srcset')) img.removeAttribute('srcset');
            img.src = urls[target];
          }
        }
      }
    }
    // Update model line — dedicated element, not inside the title link
    if (!card) return;
    var modelLine = card.querySelector('[data-wrapgram-model-line]');
    if (modelLine) {
      modelLine.textContent = displayName;
      modelLine.style.display = '';
    }
  });
}

// --- Custom lazy-load for collection card images ---
// Native loading="lazy" was racing its own internal fetch-on-reveal against this file's
// personalization writes: it could fetch whatever URL happened to be sitting in src the instant
// the image neared the viewport, independent of and simultaneous with a JS-driven correction —
// producing a real (if zero-byte, quickly-aborted) duplicate request every time. Replacing it with
// an IntersectionObserver we control means the FIRST src ever assigned to a card image is already
// the correct one for the current device (or the generic default if none is set) — nothing is ever
// fetched, then immediately replaced. Off-screen cards still fetch nothing at all until they're
// about to be seen, same bandwidth behavior as loading="lazy", just without the race.
function wrapgramResolveCardImageUrl(raw, caseType) {
  var urls = raw.split('|');
  var model = localStorage.getItem('wrapgram_model');
  var idx = wrapgramImageIndexFor(caseType, model);
  var target = Math.min(idx, urls.length - 1);
  return urls[target] || urls[0] || '';
}

function wrapgramRevealCardImage(img) {
  var raw = img.getAttribute('data-wrapgram-media');
  img.removeAttribute('data-wrapgram-card-deferred');
  if (!raw) return;
  var card = img.closest('[data-wrapgram-card]');
  var caseType = card ? card.getAttribute('data-wrapgram-case-type') : '';
  var url = wrapgramResolveCardImageUrl(raw, caseType);
  if (url) {
    // wrapgram-img-loading (the branded placeholder background, component-card.css) comes off
    // only once this specific image has actually finished downloading - not the instant src is
    // assigned above, and not by assuming the photo paints over it. Wrapgram's product renders
    // are transparent-background cutouts, so a background left behind a *loaded* photo would
    // show through its transparent margin forever instead of just during the real loading gap.
    img.addEventListener('load', function() { img.classList.remove('wrapgram-img-loading'); }, { once: true });
    img.src = url;
  }
}

var wrapgramCardImageObserver = ('IntersectionObserver' in window)
  ? new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          wrapgramRevealCardImage(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '800px 0px' })
  : null;

function wrapgramInitCardImageObserver() {
  var vh = window.innerHeight || document.documentElement.clientHeight;
  document.querySelectorAll('img[data-wrapgram-card-deferred]').forEach(function(img) {
    if (wrapgramCardImageObserver) {
      // Elements inserted via synchronous DOM mutation (e.g. Load More's appendChild) can sit
      // unobserved-in-practice until some later scroll/resize forces the browser to run its next
      // intersection check — even though rootMargin already puts them in range right now. Checking
      // getBoundingClientRect directly here reveals anything already visible immediately, and only
      // hands off to the observer for cards genuinely still off-screen (preserving the actual
      // lazy-load bandwidth savings for those).
      var rect = img.getBoundingClientRect();
      if (rect.bottom > -800 && rect.top < vh + 800) {
        wrapgramRevealCardImage(img);
      } else {
        wrapgramCardImageObserver.observe(img);
      }
    } else {
      // No IntersectionObserver support (very old browser) — reveal immediately rather than
      // never loading the image at all.
      wrapgramRevealCardImage(img);
    }
  });
}

// --- Restore card titles when model is cleared ---
function wrapgramClearCardPersonalization() {
  document.querySelectorAll('[data-wrapgram-model-line]').forEach(function(el) {
    el.textContent = '';
    el.style.display = 'none';
  });
}

// --- Show/hide Add to Cart buttons based on model ---
function wrapgramUpdateCardActions() {
  var hasModel = !!localStorage.getItem('wrapgram_model');
  document.querySelectorAll('[data-wrapgram-card-actions]').forEach(function(el) {
    el.classList.toggle('wrapgram-card-actions--visible', hasModel);
  });
}

// --- Collection card: Add to Cart / Buy Now ---
document.addEventListener('click', function(e) {
  var addBtn = e.target.closest('[data-wrapgram-add-to-cart]');
  var buyBtn = e.target.closest('[data-wrapgram-buy-now]');
  var btn = addBtn || buyBtn;
  if (!btn) return;
  e.preventDefault();
  e.stopPropagation();

  var card = btn.closest('[data-wrapgram-card]');
  if (!card) return;

  var caseType = card.getAttribute('data-wrapgram-case-type') || '';
  var vdata = card.getAttribute('data-wrapgram-vdata') || '';
  var variantId = 0;
  if (vdata) {
    var entries = vdata.split('|');
    var matched = false;
    for (var i = 0; i < entries.length; i++) {
      var colon = entries[i].indexOf(':');
      if (colon === -1) continue;
      var vid = parseInt(entries[i].substring(0, colon), 10);
      var vtitle = entries[i].substring(colon + 1);
      if (!variantId) variantId = vid;
      if (caseType && vtitle.indexOf(caseType) !== -1 && !matched) { variantId = vid; matched = true; }
    }
  }
  if (!variantId) return;

  var cardImg = card.querySelector('img[data-wrapgram-product-card]');
  var overrideBrand = card.getAttribute('data-wrapgram-override-brand') || '';
  var overrideModel = card.getAttribute('data-wrapgram-override-model') || '';
  wrapgramAddToCart(variantId, 1, cardImg ? cardImg.src : '', !!buyBtn, btn, overrideBrand, overrideModel);
});

// --- Product page: intercept Dawn form submit (capture phase fires before Dawn's handler) ---
document.addEventListener('submit', function(e) {
  var form = e.target;
  if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;
  if (!form.querySelector('.product-form__submit')) return;
  if (!document.querySelector('.product__title h1')) return;

  e.preventDefault();
  e.stopImmediatePropagation();

  var variantInput = form.querySelector('.product-variant-id, [name="id"]');
  if (!variantInput) return;
  var variantId = parseInt(variantInput.value, 10);
  if (!variantId) return;

  var quantityInput = form.querySelector('[name="quantity"]');
  var quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;

  var activeImg = document.querySelector('li.product__media-item.is-active img');
  var imageUrl = activeImg ? activeImg.src : '';

  wrapgramAddToCart(variantId, quantity, imageUrl, false, form.querySelector('.product-form__submit'));
}, true);

// --- Product page: Buy Now button (snippets/buy-buttons.liquid) — same variant/quantity
// detection as the form-submit handler above, just triggered by its own button instead of the
// regular Add to Cart submit, and isBuyNow: true so wrapgramAddToCart redirects to checkout afterward.
document.addEventListener('click', function(e) {
  var buyNowBtn = e.target.closest('[data-wrapgram-product-buy-now]');
  if (!buyNowBtn) return;
  e.preventDefault();

  var form = buyNowBtn.closest('form');
  var variantInput = form && form.querySelector('.product-variant-id, [name="id"]');
  var variantId = variantInput && parseInt(variantInput.value, 10);
  if (!variantId) return;

  var quantityInput = form.querySelector('[name="quantity"]');
  var quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;

  var activeImg = document.querySelector('li.product__media-item.is-active img');
  var imageUrl = activeImg ? activeImg.src : '';

  wrapgramAddToCart(variantId, quantity, imageUrl, true, buyNowBtn);
});

window.addEventListener('wrapgram:context-changed', function() {
  wrapgramRemoveProductCTA();
  wrapgramRemoveCollectionBanner();
  wrapgramPersonalize();
  wrapgramPersonalizeCards();
  wrapgramUpdateCardActions();
  wrapgramApplyCaseTypeFilter(localStorage.getItem('wrapgram_model'), 'model');
  wrapgramHandleProductCompatibility(localStorage.getItem('wrapgram_model'));
  if (window.WrapgramWishlist) window.WrapgramWishlist.sync();
});

window.addEventListener('wrapgram:context-cleared', function() {
  wrapgramClearCardPersonalization();
  wrapgramUpdateCardActions();
  wrapgramInjectProductCTA();
  wrapgramInjectCollectionBanner();
  // Reset the product-page gallery back to the position-2 default — otherwise it stays on
  // whichever device's slide was last shown instead of falling back correctly.
  wrapgramPersonalize();
});

document.addEventListener('DOMContentLoaded', function() {
  // Unconditional — every card needs its deferred image observed regardless of whether a
  // device is set yet (wrapgramRevealCardImage falls back to the generic default when it isn't).
  wrapgramInitCardImageObserver();

  var wrapgramInitialModel = localStorage.getItem('wrapgram_model');
  // Defer to after first paint: default images/content load first (FCP), then we swap immediately after.
  requestAnimationFrame(function() {
    // wrapgramPersonalize() runs regardless of whether a model is set — position 1 is a blank
    // checkout-only placeholder now, so even with no device selected the product gallery still
    // needs to swap onto the real fallback photo at position 2 instead of leaving Shopify's own
    // server-rendered default (position 1) showing.
    wrapgramPersonalize();
    if (wrapgramInitialModel) {
      wrapgramPersonalizeCards();
      wrapgramUpdateCardActions();
      wrapgramApplyCaseTypeFilter(wrapgramInitialModel, 'page');
      wrapgramHandleProductCompatibility(wrapgramInitialModel);
    }
  });
  if (!wrapgramInitialModel) {
    wrapgramInjectProductCTA();
    wrapgramInjectCollectionBanner();
  }

  wrapgramInitInfiniteScroll();

  // Re-apply after Dawn's facets AJAX replaces #ProductGridContainer
  var gridContainer = document.getElementById('ProductGridContainer');
  if (gridContainer) {
    new MutationObserver(function() {
      wrapgramInitInfiniteScroll();
      wrapgramInitCardImageObserver(); // newly-injected cards need to be observed too
      requestAnimationFrame(function() {
        var model = localStorage.getItem('wrapgram_model');
        if (model) {
          wrapgramPersonalizeCards();
          wrapgramApplyCaseTypeFilter(model);
        }
        wrapgramUpdateCardActions();
        if (window.WrapgramWishlist) window.WrapgramWishlist.sync();
      });
    }).observe(gridContainer, { childList: true });
  }

  // Re-apply after product-recommendations AJAX loads on product page (fix #6). Dawn's
  // <product-recommendations> ("You may also like" / cart complementary products) loads its cards via
  // its own IntersectionObserver + fetch, injecting them with innerHTML well after DOMContentLoaded —
  // outside #ProductGridContainer, so the MutationObserver above never sees them. This block already
  // re-ran wrapgramPersonalizeCards()/wrapgramUpdateCardActions() for those cards, but never called
  // wrapgramInitCardImageObserver() — and wrapgramPersonalizeCards() explicitly skips any image still
  // marked data-wrapgram-card-deferred, so those images were never observed and never revealed,
  // leaving the 1x1 placeholder showing forever. Also switched to querySelectorAll: a page can have
  // more than one <product-recommendations> (e.g. related-products plus a complementary-products
  // widget), and querySelector only ever wired up the first.
  document.querySelectorAll('product-recommendations').forEach(function(relatedSection) {
    new MutationObserver(function() {
      wrapgramInitCardImageObserver();
      requestAnimationFrame(function() {
        var model = localStorage.getItem('wrapgram_model');
        if (model) wrapgramPersonalizeCards();
        wrapgramUpdateCardActions();
        if (window.WrapgramWishlist) window.WrapgramWishlist.sync();
      });
    }).observe(relatedSection, { childList: true });
  });
});

// S18: cross-tab sync — fires when another tab writes to localStorage
window.addEventListener('storage', function(e) {
  if (e.key === 'wrapgram_model' && e.newValue) {
    wrapgramRemoveProductCTA();
    wrapgramRemoveCollectionBanner();
    wrapgramPersonalize();
    wrapgramPersonalizeCards();
    wrapgramUpdateCardActions();
    wrapgramApplyCaseTypeFilter(e.newValue);
  }
  if (e.key === 'wrapgram_model' && !e.newValue) {
    wrapgramClearCardPersonalization();
    wrapgramUpdateCardActions();
  }
});

window.WrapgramProductPersonalization = { personalize: wrapgramPersonalize };
